import { render, staticRenderFns } from "./SettingsTripPolicyView.vue?vue&type=template&id=0a3352e1&scoped=true&"
import script from "./SettingsTripPolicyView.vue?vue&type=script&lang=js&"
export * from "./SettingsTripPolicyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3352e1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VRow,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3352e1')) {
      api.createRecord('0a3352e1', component.options)
    } else {
      api.reload('0a3352e1', component.options)
    }
    module.hot.accept("./SettingsTripPolicyView.vue?vue&type=template&id=0a3352e1&scoped=true&", function () {
      api.rerender('0a3352e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsTripPolicyView.vue"
export default component.exports